const Style = {
  base: 'relative block text-red-500 text-sm mt-2 mb-4',
};

export default Style;
